import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Collapsible } from '../ui';

interface Props {
  contact: string | null;
}

export function EmergencyBlock({ contact }: Props) {
  const { t } = useTranslation();
  if (!contact) return null;
  const tel = toTelHref(contact);
  return (
    <Collapsible
      title={t('stations.stay.emergency.title')}
      icon={<Phone className="size-4" aria-hidden />}
    >
      <p className="text-fg whitespace-pre-wrap text-sm leading-relaxed">{contact}</p>
      {tel && (
        <a
          href={`tel:${tel}`}
          className="text-accent hover:text-accent-deep mt-2 inline-flex items-center gap-1.5 text-sm font-medium"
        >
          <Phone className="size-3.5" aria-hidden />
          {t('stations.stay.emergency.call')}
        </a>
      )}
    </Collapsible>
  );
}

// Extract first phone-like token (digits, +, spaces, dashes, parens). The contact field
// may contain a name + number ("Hausverwaltung: +49 30 123456"); tel: needs only digits.
function toTelHref(s: string): string | null {
  const match = s.match(/\+?[\d\s().-]{6,}/);
  if (!match) return null;
  return match[0].replace(/[^\d+]/g, '');
}
